
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/question",
      function () {
        return require("private-next-pages/customer/question/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/question"])
      });
    }
  